export const responseMessages = {
    UNKNOWN_ERROR: "Unknown error occurred"
}